(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rogue-product-content"] && !Shopify.designMode) return;
  try {
    var videoConfig = document.querySelector('[data-ri-video-url]');
  var openButton = document.getElementById('kpOpenVideo');
  var modal = document.getElementById('kpVideoModal');
  var closeButton = document.getElementById('kpCloseVideo');
  var frame = document.getElementById('kpVideoFrame');

  if (videoConfig && openButton && modal && closeButton && frame) {
    openButton.setAttribute('role', 'button');
    openButton.setAttribute('tabindex', '0');
    openButton.setAttribute('aria-haspopup', 'dialog');
    modal.setAttribute('aria-hidden', 'true');
    frame.setAttribute('title', 'Rogue Iron product video');

    var openVideo = function () {
      modal.style.display = 'flex';
      modal.setAttribute('aria-hidden', 'false');
      frame.src = videoConfig.dataset.riVideoUrl;
      closeButton.focus();
    };

    var closeVideo = function () {
      modal.style.display = 'none';
      modal.setAttribute('aria-hidden', 'true');
      frame.src = '';
      openButton.focus();
    };

    openButton.addEventListener('click', openVideo);
    openButton.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openVideo();
      }
    });
    closeButton.addEventListener('click', closeVideo);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeVideo();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.style.display === 'flex') closeVideo();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
